import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  isActive?: boolean;
}

const TalkIcon: React.FC<IconProps> = ({
  width = 16,
  height = 16,
  isActive = false,
  ...props
}) => (
  <svg
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.33334 8.50001C2.33246 7.14561 2.80291 5.83311 3.66398 4.78766C4.52505 3.74221 5.72308 3.02898 7.05255 2.77029C8.38202 2.51161 9.76007 2.72362 10.9503 3.36993C12.1406 4.01625 13.0688 5.0566 13.5758 6.31251C13.6597 6.51593 13.8207 6.6779 14.0235 6.7631C14.2264 6.8483 14.4547 6.84981 14.6587 6.76729C14.8627 6.68478 15.0258 6.52494 15.1123 6.32265C15.1989 6.12036 15.202 5.89205 15.1208 5.68751C14.7354 4.72641 14.1551 3.85551 13.4166 3.12964C12.6781 2.40376 11.7973 1.83862 10.8297 1.4698C9.86208 1.10097 8.8286 0.936449 7.79429 0.986581C6.75999 1.03671 5.74726 1.30042 4.81985 1.76109C3.89245 2.22176 3.07045 2.86943 2.4056 3.66333C1.74075 4.45723 1.24744 5.38016 0.956727 6.37404C0.666016 7.36791 0.584196 8.41121 0.716418 9.43825C0.848639 10.4653 1.19204 11.4538 1.725 12.3417L1.075 14.5492C1.03228 14.694 1.02939 14.8477 1.06665 14.9941C1.1039 15.1404 1.17993 15.274 1.28671 15.3808C1.3935 15.4876 1.5271 15.5636 1.67345 15.6009C1.8198 15.6381 1.97349 15.6352 2.11834 15.5925L4.32667 14.9425C5.21486 15.4737 6.20388 15.8143 7.23083 15.9425C7.45019 15.9699 7.67145 15.9091 7.84594 15.7733C8.02042 15.6376 8.13385 15.4381 8.16125 15.2188C8.18866 14.9994 8.1278 14.7781 7.99207 14.6037C7.85634 14.4292 7.65686 14.3158 7.4375 14.2883C6.58315 14.182 5.76327 13.8865 5.0375 13.4233C4.89425 13.3317 4.73305 13.2719 4.56474 13.2477C4.39643 13.2236 4.2249 13.2357 4.06167 13.2833L3.10167 13.5658L3.38417 12.6058C3.48417 12.2658 3.42334 11.9108 3.24417 11.6308C2.64742 10.6958 2.33132 9.60925 2.33334 8.50001ZM15.6667 12.25C15.6666 11.6028 15.4513 10.9741 15.0547 10.4627C14.658 9.95131 14.1025 9.58638 13.4757 9.42535C12.8489 9.26433 12.1863 9.31635 11.5923 9.57323C10.9983 9.8301 10.5066 10.2773 10.1946 10.8443C9.88263 11.4113 9.76809 12.0659 9.86903 12.7052C9.96997 13.3445 10.2807 13.932 10.7522 14.3753C11.2237 14.8186 11.8292 15.0925 12.4735 15.1538C13.1178 15.2152 13.7641 15.0605 14.3108 14.7142C14.5359 14.571 14.807 14.5189 15.0692 14.5683C15.0194 14.3063 15.0713 14.0352 15.2142 13.81C15.5097 13.3434 15.6666 12.8024 15.6667 12.25ZM12.75 7.66668C13.5463 7.66662 14.3289 7.87403 15.0206 8.26847C15.7124 8.6629 16.2894 9.23076 16.6949 9.91609C17.1004 10.6014 17.3204 11.3806 17.3331 12.1768C17.3458 12.973 17.1509 13.7587 16.7675 14.4567L17.0892 15.5492C17.1317 15.6936 17.1345 15.8467 17.0974 15.9926C17.0602 16.1384 16.9844 16.2716 16.878 16.378C16.7716 16.4844 16.6384 16.5602 16.4926 16.5974C16.3467 16.6345 16.1935 16.6317 16.0492 16.5892L14.9575 16.2675C14.345 16.6039 13.6636 16.7957 12.9656 16.8283C12.2675 16.861 11.5712 16.7336 10.93 16.4559C10.2887 16.1781 9.71944 15.7575 9.26569 15.226C8.81195 14.6945 8.48574 14.0663 8.31201 13.3894C8.13829 12.7126 8.12164 12.0049 8.26334 11.3206C8.40504 10.6363 8.70135 9.99349 9.12959 9.44127C9.55784 8.88905 10.1067 8.44206 10.7342 8.13449C11.3617 7.82692 12.0512 7.6669 12.75 7.66668Z"
      fill={isActive ? 'url(#gradient)' : '#333333'}
    />
    {isActive && (
      <defs>
        <linearGradient
          id="gradient"
          x1="0.655006"
          y1="8.90557"
          x2="17.1325"
          y2="7.08469"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FD84BE" />
          <stop offset="0.5" stopColor="#FB7BDB" />
          <stop offset="1" stopColor="#BF78F2" />
        </linearGradient>
      </defs>
    )}
  </svg>
);

export default TalkIcon;
